import React, { forwardRef } from 'react'

import Action from './Action'
import { middlePanelStyles } from '../../../styles/classes/FormBuilderClasses'

const Handle = forwardRef((props, ref) => {
  const { classes } = middlePanelStyles()
  return (
    <Action
      ref={ref}
      cursor="grab"
      data-cypress="draggable-handle"
      {...props}
      className={classes.handleStyle}
    />
  )
})

Handle.displayName = 'Handle'
export default Handle
